function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 7.442C19.449 7.687 18.855 7.853 18.232 7.926C18.868 7.546 19.356 6.943 19.586 6.224C18.991 6.577 18.333 6.833 17.632 6.971C17.07 6.374 16.271 6 15.386 6C13.687 6 12.309 7.378 12.309 9.077C12.309 9.318 12.336 9.552 12.389 9.778C9.83 9.65 7.562 8.424 6.045 6.563C5.78 7.017 5.628 7.546 5.628 8.11C5.628 9.177 6.172 10.12 6.997 10.671C6.493 10.655 6.019 10.517 5.604 10.287C5.603 10.299 5.603 10.312 5.603 10.325C5.603 11.816 6.664 13.059 8.072 13.342C7.813 13.413 7.542 13.451 7.261 13.451C7.062 13.451 6.87 13.431 6.682 13.395C7.073 14.618 8.21 15.507 9.557 15.532C8.503 16.358 7.177 16.85 5.734 16.85C5.486 16.85 5.241 16.836 5 16.806C6.362 17.68 7.98 18.189 9.718 18.189C15.379 18.189 18.474 13.501 18.474 9.433C18.474 9.3 18.471 9.167 18.465 9.035C19.066 8.602 19.588 8.059 20 7.442Z",
  fill: "#EC404A"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1a61cd0c.svg";
export { ForwardRef as ReactComponent };